/* eslint-disable consistent-return */
import request from 'utils/request';
import _ from 'lodash';
import { USER_TYPE } from 'constants/common';

export const getOffers = async (machineId) => {
  const data = await request(`api/v1/offers/machine/${machineId}`, 'get', { host: process.env.marketplace });
  return data;
};

export const bidNow = async (machineId, userId, offer) => {
  const data = await request(`api/v1/marketplace/placeOffer/${machineId}`, 'post', {
    host: process.env.marketplace,
    body: JSON.stringify({
      userId,
      offer: _.replace(offer, /,|\./gi, ''),
    }),
  });
  return data;
};

export const getCounterOffer = async (offerId) => {
  const data = await request(`api/v1/counterOffers/offers/${offerId}`, 'get', { host: process.env.marketplace });
  return data;
};

export const acceptCounterOffer = async (counteredReferanceId) => {
  const data = await request(`api/v1/counterOffers/counter/${counteredReferanceId}/accept`, 'post', { host: process.env.marketplace });
  return data;
};

export const rejecetCounterOffer = async (counteredReferanceId) => {
  const data = await request(`api/v1/counterOffers/counter/${counteredReferanceId}/reject`, 'post', { host: process.env.marketplace });
  return data;
};

export const makeCounterOffer = async (offerId, counteredReferance, offer) => {
  const data = await request(`api/v1/counterOffers/counter/${offerId}/${counteredReferance}/counter`, 'post', {
    host: process.env.marketplace,
    body: JSON.stringify({
      offer,
      counteredBy: USER_TYPE.BUYER,
    }),
  });
  return data;
};

export const checkoutOffer = async (orderId, verificationCode) => {
  const data = await request(`api/v1/orders/${orderId}/verify`, 'post', {
    body: JSON.stringify({
      verificationCode,
    }),
  });
  return data;
};

export const buyNow = async (machineId, userId) => {
  const data = await request(`api/v1/marketplace/buyNow/${machineId}`, 'post', {
    host: process.env.marketplace,
    body: JSON.stringify({
      userId,
    }),
  });
  return data;
};

export const getResendVerficationCode = async (orderId) => {
  const { message } = await request(`api/v1/orders/buyNow/resendVerificationCode/${orderId}`, 'get');
  return message;
};

export const getMachineSoldPrice = async (machineId) => {
  const { machineSoldPrice } = await request(`api/v1/machines/${machineId}/soldPrice`, 'get');
  return machineSoldPrice;
};

export const getHighestBidder = async (machineId) => {
  const { highestBidder } = await request(`api/v1/marketplace/highestBidder/${machineId}`, 'get', { host: process.env.marketplace });
  return highestBidder;
};
